import type { Graph, Thing } from "schema-dts"
import JsonLd from "@/components/core/seo/JsonLd"
import { breadcrumbSchema, BreadcrumbItem } from "@/lib/schema"

type SchemaNode = Exclude<Thing, string>

type Props = {
	/**
	 * Breadcrumb levels below "Home" (which is added automatically), ending
	 * with the current page. Use real page titles, not slug-derived guesses.
	 */
	breadcrumbs?: BreadcrumbItem[]
	/** Page-specific schema node(s), built via the builders in src/lib/schema.ts. */
	schema?: SchemaNode | SchemaNode[]
}

/**
 * Renders a page's structured data as a single JSON-LD @graph. Every page
 * should render this with a meaningful schema and/or breadcrumb trail;
 * the Organization and WebSite nodes come from the root layout.
 */
export default function PageJsonLd({ breadcrumbs, schema }: Props) {
	const nodes: SchemaNode[] = [
		...(breadcrumbs?.length ? [breadcrumbSchema(breadcrumbs)] : []),
		...(schema ? (Array.isArray(schema) ? schema : [schema]) : []),
	]

	if (nodes.length === 0) return null

	const graph: Graph = {
		"@context": "https://schema.org",
		"@graph": nodes,
	}

	return <JsonLd data={graph} />
}
